angular
    .module('empower.uploadDocument')
    .constant('uploadDocumentWording', {
        UPLOAD_SUCCESS: 'Thank you. The uploaded document will be sent to our staff for processing!',
        POLICY_OR_CLAIM_REQUIRED: 'Please select a policy or claim'
    });